import React from 'react'
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import LoginTile from './LoginTile';
import Cookies from 'js-cookie';

function CommentTile({ collectionGroupId, documentId, parentId, commentEntry, idx }) {

  let baseComment = commentEntry;

  const childComments = baseComment.children;
  const navigate = useNavigate();

  const getUserName = () => {
    const user = Cookies.get('username');
    if (user) {
      return user;
    } else {
      return '';
    }
  }


  const formattedDate = new Date(baseComment.created).toLocaleDateString(); // Uses default locale

  const [editable, setEditable] = useState(false);
  const [replyEditable, setReplyEditable] = useState(false);

  const [input, setInput] = useState(baseComment.comment)

  const [replyText, setReplyText] = useState("");

  const [showReplyInput, setShowReplyInput] = useState(false);

  const [commentVisible, setCommentVisible] = useState(true);
  const [addingNewComment, setAddingNewComment] = useState(false);
  const [addedCommentText, setAddedCommentText] = useState("");
  const [addedCommentEditable, setAddedCommentEditable] = useState(false);
  const [allowNewComment, setAllowNewComment] = useState(true);


  const [replyRecord, setReplyRecord] = useState({
    id: null,
    created: null,
    collectionGroupId: collectionGroupId,
    documentId: documentId,
    parent: { "id": baseComment.id },
  });

  const [addedCommentRecord, setAddedCommentRecord] = useState({
    id: null,
    created: null,
    collectionGroupId: collectionGroupId,
    documentId: documentId,
    parent: null,
  });

  const handleAddingNewComment = () => {
    if (getUserName()) {
      setAddingNewComment(true);
      setAddedCommentEditable(true);
    } else {
      setShowErrorMessage(true);
    }
  }

  const formatDate = (d) => {
    return d.toLocaleDateString();
  }

  const handleReply = (e) => {
    if (getUserName()) {
      setShowReplyInput(true);
      setReplyEditable(true);
    } else {
      setShowErrorMessage(true);
    }
  }

  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const handleReplyCancel = (e) => {
    setShowReplyInput(false);
    setReplyText("");
  }
  const [showLoginWindow, setShowLoginWindow] = useState(false);


  const handleLoginTileReturn = (sts) => {
    setShowLoginWindow(false);
  }
  const handleAddedCommentCancel = (e) => {
    setAddedCommentEditable(false);
    setAddingNewComment(false);
    setAddedCommentRecord();
    setAddedCommentText("");

  }
  const handleEdit = (e) => {
    setEditable(true);
  }

  const handleDelete = (e) => {
    deleteComment(baseComment.id, 0);
    setCommentVisible(false);
  }

  const handleDeleteReply = (e) => {
    deleteComment(replyRecord.id);
    setReplyRecord({
      id: null,
      created: null,
      collectionGroupId: collectionGroupId,
      documentId: documentId,
      parent: { "id": baseComment.id },
    });
    setShowReplyInput(false);
  }

  const handleAddedCommentDelete = (e) => {
    deleteComment(addedCommentRecord.id);
    setAddedCommentRecord
      ({
        id: null,
        created: null,
        collectionGroupId: collectionGroupId,
        documentId: documentId,
        parent: null,
      });
    setAddingNewComment(false);
  }

  const handleCancel = (e) => {
    setEditable(false);
  }

  const handleSave = (e) => {
    baseComment.comment = input;
    saveComment();
    setEditable(false);
  }

  const handleReplySave = (e) => {
    saveReplyComment();
    setReplyEditable(false);

  }

  const handleSaveAddedComment = (e) => {
    saveAddedComment();
    setAddedCommentEditable(false);
  }


  const deleteComment = async (commentId, baseOrReply) => {
    axios
      .delete("/api/v1/comments/" + commentId)
      .then((result) => { })
      .catch((err) => console.log(err));

  }

  const saveReplyComment = async () => {
    let tmpComment = replyRecord;
    tmpComment.comment = replyText;
    axios
      .post("/api/v1/comments", tmpComment)
      .then((result) => setReplyRecord(result.data))
      .catch((err) => console.log(err));
  }

  const saveComment = async () => {
    let tmpComment = baseComment;
    tmpComment.created = null;
    tmpComment.collectionGroupId = collectionGroupId;
    tmpComment.documentId = documentId;

    if (parentId === 0) {
      tmpComment.parent = null;
    } else {
      tmpComment.parent = { "id": parentId }
    }

    if (baseComment.id !== null) {
      axios
        .put("/api/v1/comments", tmpComment)
        .then((result) => {
          baseComment = result.data
        })
        .catch((err) => console.log(err));
    }
  }


  const saveAddedComment = async () => {
    let tmpComment = addedCommentRecord;
    tmpComment.comment = addedCommentText;
    axios
      .post("/api/v1/comments", tmpComment)
      .then(function (response) {
        if (response.status === 200) {
          setAddedCommentRecord(response.data);
        }
      })
      .catch((err) => console.log(err));
  }


  return (
    <div>
      <div style={{ display: idx === 0 ? "block" : "none" }}>
        <input style={{ display: (allowNewComment) ? "block" : "none" }} type="button" value="New Comment" onClick={handleAddingNewComment} />
        <div style={{ paddingLeft: "50", display: (addingNewComment && getUserName()) ? "block" : "none" }}>
          <div className="commentContainer" >
            <span style={{ marginBottom: "10px" }}>
              On {formatDate(new Date())}, {getUserName()} said:
              <hr />
            </span>
            {addedCommentEditable ?
              <div>
                <div className="commentInputContainer">
                  <textarea
                    rows="5"
                    className="commentInputContainer__input"
                    autoFocus
                    onChange={(e) => setAddedCommentText(e.target.value)}
                    value={addedCommentText}
                  />
                </div>
                <div>
                  <hr />
                  <span className="commentReply" onClick={handleSaveAddedComment}>Save</span>
                  <span className="commentReply" onClick={handleAddedCommentCancel}>Cancel</span>
                </div>
              </div>
              :
              <div>
                <div>
                  <div>
                    <div>
                      <span style={{ wordWrap: "break-word" }}>
                        {addedCommentText}
                      </span>
                      <div>
                        <hr />
                        <span className="commentReply" onClick={handleAddedCommentDelete}>Delete</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

      </div>

      <div style={{ display: commentVisible ? "block" : "none" }}>
        <div style={{ paddingLeft: "50" }}>
          <div className="commentContainer" >

            <span style={{ marginBottom: "10px" }}>
              On {formattedDate}, {baseComment.commentUserName} said:
              <hr />
            </span>
            {!editable ?
              <div>
                <div>
                  <span style={{ wordWrap: "break-word" }}>
                    {baseComment.comment}
                  </span>
                  <div>
                    <hr />
                    <span className="commentReply" onClick={handleReply}>Reply</span>
                    {(baseComment.mine && childComments.length === 0) &&
                      <span className="commentReply" onClick={handleEdit}>Edit</span>
                    }
                    {(baseComment.mine && childComments.length === 0) &&
                      <span className="commentReply" onClick={handleDelete}>Delete</span>
                    }
                  </div>
                </div>
              </div>
              :
              <div>
                <div className="commentInputContainer">
                  <textarea
                    rows="5"
                    className="commentInputContainer__input"
                    autoFocus
                    onChange={(e) => setInput(e.target.value)}
                    value={input}
                  />
                </div>
                <div>
                  <hr />
                  <span className="commentReply" onClick={handleSave}>Save</span>
                  <span className="commentReply" onClick={handleCancel}>Cancel</span>
                </div>
              </div>
            }
          </div>
          {showReplyInput &&
            <div className="commentIndent" style={{ paddingLeft: "50" }}>
              <div className="commentContainer" >
                <span style={{ marginBottom: "10px" }}>
                  On {formatDate(new Date())}, {getUserName()} said:
                  <hr />
                </span>
                {!replyEditable ?
                  <div>
                    <div>
                      <span style={{ wordWrap: "break-word" }}>
                        {replyText}
                      </span>
                      <div>
                        <hr />
                        <span className="commentReply" onClick={handleDeleteReply}>Delete</span>
                      </div>
                    </div>
                  </div>
                  :
                  <div className="commentInputContainer">
                    <textarea
                      rows="5"
                      className="commentInputContainer__input"
                      autoFocus
                      onChange={(e) => setReplyText(e.target.value)}
                      value={replyText}
                    />
                    <div>
                      <hr />
                      <span className="commentReply" onClick={handleReplySave}>Save</span>
                      <span className="commentReply" onClick={handleReplyCancel}>Cancel</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <div className="commentIndent">
            {
              childComments.map((commentEntry, index) => (
                <CommentTile key={index} collectionGroupId={collectionGroupId} documentId={documentId} parentId={baseComment.id} commentEntry={commentEntry} idx={99} />
              ))
            }
          </div>
        </div >
      </div>
      {showErrorMessage && (
        <div className="overlay">
          <div className="popup">
            <h3>Error</h3>
            <p>Only registered users can contribute to the debate.</p>
            <div className="header-link">
              <div onClick={() => navigate("/Register.html")}>Register</div>
              <div onClick={() => { setShowErrorMessage(false); setShowLoginWindow(true); }}>Login</div>
              <button onClick={() => setShowErrorMessage(false)}>Ok</button>
            </div>
          </div>
        </div>
      )}
      {showLoginWindow && (
        <LoginTile sendValueBack={handleLoginTileReturn} />
      )}
    </div>
  )

}

export default CommentTile
